<template>
  <div class="map-pupup-route" v-if="isVisible">
    <b-modal content-class="content-fullscreen" dialog-class="modal-fullscreen" hide-backdrop scrollable hide-footer size="xl" @hide="onCloseModal" @shown="onOpenedModal" ref="map-modal" :title="title">
      <div v-if="mapState === 'loading'">
        <p style="margin-bottom: 0px; text-align: center;">Loading data...</p>
      </div>
      <div v-if="mapState === 'failed'">
        <p style="margin-bottom: 0px;">Failed fetch data :(</p>
      </div>
      <div v-if="mapState === 'ready'">
        <div class="setup-tooltip">
            <b-form-checkbox
              v-model="tooltipCheckbox"
              name="tooltip-check"
              value="show-tooltip"
              unchecked-value="hide-tooltip"
            > Show Tooltip </b-form-checkbox>
        </div>
        <br>
        <l-map
          @ready="onMapReady"
          ref="map"
          style="height: 500px; width: 100%;"
          :min-zoom="min_zoom"
          :max-zoom="max_zoom"
          :bounds="bounds"
          :zoom.sync="zoom"
          :center="center">
          <l-tile-layer :url="url"></l-tile-layer>
          <l-marker v-for="(marker, markerIdx) in markerPoints"
            :key="`marker-${markerIdx}`"
            :lat-lng="getMarkerPoint(marker)"
            :icon="getMarkerIcon(marker)">
            <l-tooltip :options="tooltipOptions">
              <p style="margin-bottom: 0px;">
                <span v-if="marker.type === 'destination'">
                  <b>{{ get(marker, 'customer.name') }}</b>
                </span>
                <span v-if="marker.type === 'origin'">
                  <b>Origin Area</b>
                </span>
                <span v-if="marker.type === 'vehicle'">
                  <b>Current Location</b>
                </span>
              </p>
              <p style="margin-bottom: 0px;">{{ get(marker, 'name') }}</p>
              <p v-if="marker.type === 'destination'" style="margin-bottom: 0px; font-size: 18px;">
                <b-badge variant="primary" pill>
                  <!-- <b>{{ marker.sequence === null ? 1 : Number(marker.sequence) + 1 }}</b> -->
                  <b>{{ marker.destinationIdxArr ? marker.destinationIdxArr.join(', ') : '-' }}</b>
                </b-badge>
              </p>
            </l-tooltip>
          </l-marker>
          <l-polygon v-for="(poly, polyIdx) in polyCollections"
            :latLngs="get(poly, 'geometry.coordinates')"
            :key="`poly-${polyIdx}`"></l-polygon>
          <l-circle v-for="(circle, circleIdx) in circleCollections"
            :lat-lng="getCircleCoordinates(circle)"
            :radius="getCircleRadius(circle)"
            :key="`circle-${circleIdx}`"></l-circle>
          <l-polyline
            v-for="(line, lineIdx) in lineCollections"
            :color="getLineColor(line)"
            :key="`line-${lineIdx}`"
            :lat-lngs="get(line, 'coordinates')"></l-polyline>
        </l-map>
        <br>
        <b-card>
          <b-card-text>
            <p style="text-align: left; margin-bottom: 0px;">
              <b>Driver: </b><span class="text-detail">{{ get(tableShipment, 'driver.name') || '-' }}</span>
              <br>
              <b>Delivery Area: </b> <span class="text-detail">{{ getVehicleWorkingArea() }}</span> | <b>Storage Type: </b> <span class="text-detail">{{ get(tableShipment, 'metadata.storage_type') || '-' }}</span>
              <br>
              <b>Total Duration: </b> <span class="text-detail">{{ formatDuration() || '-' }}</span> | <b>Total Distance: </b> <span class="text-detail">{{ formatDistance() || '-' }}</span>
              <br>
              <b>Total Deliveries: </b> <span class="text-detail">{{ getTotalDeliveries() }}</span> | <b>Total Customer: </b> <span class="text-detail">{{ getTotalCustomer() }}</span> | <b>Total Weight: </b> <span class="text-detail">{{ get(tableShipment, 'metadata.totalGross') || '-' }} / {{ get(tableShipment, 'vehicle.metadata.max_weight') || '-' }}</span> | <b>Total Volume: </b> <span class="text-detail">{{ get(tableShipment, 'metadata.totalVolume') || '-' }} / {{ get(tableShipment, 'vehicle.metadata.max_volume') || '-' }}</span>
            </p>
          </b-card-text>
        </b-card>
        <template v-if="title !== 'All Routes'">
          <div>
            <b-table
              :items="table.items"
              :fields="table.fields"
              caption-top
              small
              fixed
              responsive
              hover
              :tbody-tr-class="rowClass"
              style="overflow-x: auto;"
            >
              <template #table-caption>Details List</template>
              <template #cell(no)="data">
                <span>
                  {{ get(data.item, 'sequenceIndex') }}
                </span>
              </template>
              <template #cell(number)="data">
                <span :title="isDepot(data.item) ? '' : 'Click zoom to point'" @click="onClickNumberOrder(data.item)">
                  <b :class="isDepot(data.item) ? '' : 'text-info text-order-number'">{{ getNumber(data.item) }}</b>
                </span>
              </template>
              <template #cell(arrive_time)="data">
                <span>
                  {{ converTimeFormat(data.item) }}
                </span>
              </template>
              <template #cell(warehouse)="data">
                <span>
                  {{ getWarehouse(data.item) }}
                </span>
              </template>
              <template #cell(reference)="data">
                <span>
                  {{ get(getOrderDetail(get(data.item, 'job')), 'metadata.reference') }}
                </span>
              </template>
              <template #cell(picking_route)="data">
                <span>
                  {{ get(getOrderDetail(get(data.item, 'job')), 'metadata.picking_route') }}
                </span>
              </template>
              <template #cell(customer)="data">
                <span>
                  {{ get(getOrderDetail(get(data.item, 'job')), 'customer.name') }}
                </span>
              </template>
              <template #cell(storage_type)="data">
                <span>
                  {{ get(getOrderDetail(get(data.item, 'job')), 'metadata.storage_type') }}
                </span>
              </template>
              <template #cell(segment)="data">
                <span>
                  {{ get(getOrderDetail(get(data.item, 'job')), 'metadata.segment') }}
                </span>
              </template>
            </b-table>
          </div>
        </template>
      </div>
      <!-- <template #modal-footer>
        <b-button class="mt-3 pull-right" variant="outline-danger" @click="hideModal">Close</b-button>
      </template> -->
    </b-modal>
  </div>
</template>

<script>
import L from 'leaflet';
import { get, isNull, isNaN, orderBy, cloneDeep, isArray } from 'lodash';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LPolygon, LCircle, LPolyline } from 'vue2-leaflet';

export default {
  name: 'MapPopupRoute',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LPolygon,
    LCircle,
    LPolyline,
  },
  props: {
    title: {
      type: String,
      default: 'Map Route',
      required: true,
    },
    mapState: {
      type: String,
      default: 'loading',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    min_zoom: {
      type: Number,
      default: 1,
      require: false,
    },
    max_zoom: {
      type: Number,
      default: 20,
      require: false,
    },
    zoom: {
      type: Number,
      default: 13,
      require: false,
    },
    center: {
      type: Array,
      default() {
        return [-6.17543846855061, 106.86290799928327];
      },
      require: false,
    },
    markerPoints: {
      type: Array,
      default() {
        return [];
      },
    },
    tableShipment: {
      type: Object,
      default: {},
    },
    polyCollections: {
      type: Array,
      default() {
        return [];
      },
    },
    circleCollections: {
      type: Array,
      default() {
        return [];
      },
    },
    lineCollections: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      tooltipOptions: {
        permanent: true,
        direction: 'top',
        offset: L.point(0, -30),
        interactive: true,
      },
      tooltipCheckbox: 'show-tooltip',
      bounds: L.latLngBounds(
        { lat: 51.476483373501964, lng: -0.14668464136775586 },
        { lat: 51.52948330894063, lng: -0.019140238291583955 },
      ),
      tooltipObjects: [],
      orders: [],
      table: {
        fields: [
          'no',
          'number',
          'arrive_time',
          'warehouse',
          'reference',
          'picking_route',
          'customer',
          'storage_type',
          'segment',
        ],
        items: [],
      },
    };
  },
  watch: {
    isVisible(show) {
      if (show) {
        setTimeout(() => {
          this.$refs['map-modal'].show();
        }, 5e2);
      }
    },
    tooltipCheckbox(value) {
      const useTooltip = value === 'show-tooltip';
      this.updateTooltipState(useTooltip);
    },
    mapState(state) {
      if (state === 'ready') {
        this.lineCollections = this.lineCollections.map((line) => {
          const { coordinates } = line;
          const switchedCoordinates = coordinates.map(coordinate => (
            [coordinate[1], coordinate[0]]
          ));
          line.coordinates = switchedCoordinates;
          return line;
        });
        const points = this.lineCollections.reduce((newArr, dt) => {
          const { coordinates } = dt;
          coordinates.forEach((coordinate) => {
            newArr.push({ lat: coordinate[0], lng: coordinate[1] });
          });
          return newArr;
        }, []);
        const bounds = L.latLngBounds(points.map(pt => (
          { lat: pt.lat, lng: pt.lng }
        )));

        this.markerPoints = orderBy(this.markerPoints, ['arrival'], ['asc']);

        this.getDataTables();
        this.bounds = bounds;
      }
    },
  },
  methods: {
    onMapReady() {
      this.pullTooltipObject();
      this.addTooltipEvent();

      const useTooltip = this.tooltipCheckbox === 'show-tooltip';
      this.updateTooltipState(useTooltip);
    },
    getDataTables() {
      let steps = cloneDeep(get(this.tableShipment, 'steps', []));
      this.orders = this.tableShipment.orders;
      this.table.items = [];
      this.table.items = steps;

      if (!isArray(steps)) {
        steps = [];
      }

      steps.forEach((step) => {
        const { childs = [] } = step;
        if (childs) {
          childs.forEach((child) => {
            const { id } = child;
            this.table.items.push({
              ...step,
              job: id,
            });
          });
        }
      });

      let destinationIndex = 1;
      const destinationIndexDt = {};
      const destinationIndexDtArr = {};

      this.table.items = orderBy(this.table.items, ['arrival'], ['asc']);
      this.table.items = this.table.items.map((dt, idx) => {
        if (dt.type === 'start' || dt.type === 'end') {
          dt.sequenceIndex = '-';
          dt.destinationIndex = '-';
        } else {
          const order = this.getOrderDetail(dt.job);
          const destinationId = get(order, 'customer.id');

          if (!destinationIndexDt[destinationId]) {
            destinationIndexDt[destinationId] = destinationIndex;
            destinationIndex++;
          }

          if (!destinationIndexDtArr[destinationId]) {
            destinationIndexDtArr[destinationId] = [idx];
          } else {
            destinationIndexDtArr[destinationId].push(idx);
          }

          dt.destinationIndex = destinationIndexDt[destinationId];
          dt.sequenceIndex = idx;
        }
        return dt;
      });
      this.markerPoints = this.markerPoints.map((dt) => {
        if (dt.type === 'destination') {
          const order = this.getOrderDetail(dt.job);
          const destinationId = get(order, 'customer.id');
          dt.destinationIdxArr = destinationIndexDtArr[destinationId];
        }
        return dt;
      });
    },
    converTimeFormat(step) {
      const arrivalInSeconds = this.get(step, 'arrival');
      const oneHourOnSeconds = 3600;
      const leftOnSeconds = arrivalInSeconds % oneHourOnSeconds;
      const timeOnHour = Math.round((arrivalInSeconds - leftOnSeconds) / 60 / 60);
      const leftOnMinutes = Math.round(leftOnSeconds / 60);

      if (!arrivalInSeconds || isNaN(leftOnMinutes)) return '';

      return timeOnHour
        ? `${timeOnHour.toString().padStart(2, '0')}:${leftOnMinutes.toString().padStart(2, '0')}`
        : `00:${leftOnMinutes.toString().padStart(2, '0')}`;
    },
    getNumber(step) {
      const stepType = step.type;
      const order = this.getOrderDetail(this.get(step, 'job'));
      let number = this.get(order, 'number');

      if (stepType === 'start' || stepType === 'end') {
        number = 'Depot / Pool';
      }

      return number;
    },
    getWarehouse(step) {
      const stepType = step.type;
      const order = this.getOrderDetail(this.get(step, 'job'));
      let warehouse = this.get(order, 'metadata.warehouse');

      if (stepType === 'start') {
        warehouse = 'Truck Arrived at Pool';
      } else if (stepType === 'end') {
        warehouse = 'Truck Return to Pool';
      }

      return warehouse;
    },
    pullTooltipObject() {
      const { mapObject } = this.$refs.map;
      this.tooltipObjects = [];
      mapObject.eachLayer((layer) => {
        if (layer.options.pane === 'tooltipPane') {
          this.tooltipObjects.push(layer);
        }
      });
    },
    addTooltipEvent() {
      this.tooltipObjects.forEach((tooltip) => {
        const tooltipElem = tooltip.getElement();
        tooltipElem.addEventListener('click', () => {
          const modalElem = document.querySelector('.content-fullscreen .modal-body');
          const tableElem = document.querySelector('.content-fullscreen table');
          if (modalElem && tableElem) {
            const tablePosition = tableElem.getBoundingClientRect();
            modalElem.scrollTo({
              left: 0,
              top: tablePosition.top || 300,
              behavior: 'smooth',
            });
          }
        });
      });
    },
    updateTooltipState(show) {
      const { mapObject } = this.$refs.map;

      if (show) {
        this.tooltipObjects.forEach((tooltip) => {
          mapObject.addLayer(tooltip);
        });
      } else {
        mapObject.eachLayer((layer) => {
          if (layer.options.pane === 'tooltipPane') {
            layer.removeFrom(mapObject);
          }
        });
      }
    },
    get(object, key) {
      return get(object, key) || '';
    },
    onOpenedModal() {
      this.$emit('on-opened-modal');
    },
    onCloseModal() {
      this.$emit('on-closed-modal');
    },
    getMarkerIcon(data) {
      let iconName = '';
      let iconPath = 'tms';
      if (data.type === 'destination' && data.percentage === 100) {
        iconName = 'destination-finish';
      } else if (data.type === 'destination' && data.percentage !== 100) {
        iconName = 'destination-waiting';
      } else if (data.type === 'origin') {
        iconName = 'origin-area';
      } else if (data.type === 'vehicle') {
        iconName = 'truck_in_movement';
        iconPath = 'bookmark';
      }
      const icon = L.icon({
        iconUrl: `https://secure-gps.street-directory.com.au/assets/img/${iconPath}/${iconName}.png`,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });
      return icon;
    },
    getMarkerPoint(data) {
      const {
        geometry = {}, longitude, latitude, type,
      } = data;
      const isCircle = geometry.type === 'Point';
      const isVehicle = type === 'vehicle';
      let point = {
        lat: null,
        lng: null,
      };

      if (isVehicle) {
        return {
          lat: latitude,
          lng: longitude,
        };
      }

      if (isCircle) {
        point = isNull(longitude) && isNull(latitude)
          ? { lat: geometry.coordinates[0], lng: geometry.coordinates[1] }
          : { lat: latitude, lng: longitude };
      } else {
        const polygon = L.polygon(geometry.coordinates);
        point = polygon.getBounds().getCenter();
      }
      return point;
    },
    getCircleRadius(data) {
      const { metadata = {} } = data;
      const radius = !isNull(metadata.radius)
        ? metadata.radius
        : this.defaultCircleRadius;
      return radius;
    },
    getCircleCoordinates(data) {
      const { geometry, longitude, latitude } = data;
      const coordinates = isNull(longitude) && isNull(latitude)
        ? geometry.coordinates
        : [latitude, longitude];
      return coordinates;
    },
    getOrderDetail(order) {
      const orderId = order.toString();
      const getOrder = this.orders.find(data => data.id === orderId);
      return getOrder;
    },
    rowClass(item) {
      let table = '';
      if (item.type === 'start') {
        table = 'table-danger';
      } else if (item.type === 'end') {
        table = 'table-danger';
      }
      return table;
    },
    getLineColor(line) {
      const lineColor = line.color ? line.color : 'red';
      return lineColor;
    },
    getSequence(data) {
      const jobId = get(data, 'job');
      if (!isNull(jobId)) {
        const order = this.getOrderDetail(jobId);
        let sequence = get(order, 'sequence');
        sequence = Number(sequence) + 1;
        return sequence;
      }
      return '-';
    },
    hideModal() {
      this.$refs['map-modal'].hide();
    },
    getVehicleWorkingArea() {
      const workingArea = get(this.tableShipment, 'vehicle.metadata.working_area') || [];
      return workingArea.join(', ') || '-';
    },
    getTotalCustomer() {
      const customerIds = [];
      const { orders = [] } = this.tableShipment;

      orders.forEach((order) => {
        const customerId = get(order, 'customer.id');
        if (!customerIds.includes(customerId)) {
          customerIds.push(customerId);
        }
      });

      return customerIds.length || '-';
    },
    getTotalDeliveries() {
      const { orders = [] } = this.tableShipment;
      return orders.length || '-';
    },
    formatDuration() {
      const oneHourOnSeconds = 3600;
      const durationOnSeconds = get(this.tableShipment, 'metadata.route.duration') || null;
      const leftOnSeconds = durationOnSeconds % oneHourOnSeconds;
      const durationOnHour = Math.round((durationOnSeconds - leftOnSeconds) / 60 / 60);
      const leftOnMinutes = Math.round(leftOnSeconds / 60);

      if (!durationOnSeconds || isNaN(leftOnMinutes)) return '';

      return durationOnHour ? `${durationOnHour}h ${leftOnMinutes}m` : `${leftOnMinutes}m`;
    },
    formatDistance() {
      const distanceOnMeter = this.get(this.tableShipment, 'metadata.route.distance') || null;
      const distanceOnKm = distanceOnMeter / 1000;

      if (!distanceOnMeter || isNaN(distanceOnKm)) return '';

      return `${distanceOnKm} Km`;
    },
    onClickNumberOrder(data) {
      const { mapObject } = this.$refs.map;

      if (mapObject) {
        const lat = data.location[1];
        const lng = data.location[0];
        const zoom = 18;
        mapObject.setView([lat, lng], zoom);
      }

      const modalElem = document.querySelector('.content-fullscreen .modal-body');
      if (modalElem) {
        modalElem.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth',
        });
      }
    },
    isDepot(data) {
      return data.type === 'start' || data.type === 'end';
    },
  },
};
</script>

<style lang="sass">
  .modal-fullscreen
    max-width: 100% !important;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
    max-height: 100% !important;

  .content-fullscreen
    max-height: 100% !important;

  .content-fullscreen .modal-body
    text-align: center;
</style>

<style lang="sass" scoped>
  @import "~leaflet/dist/leaflet.css";

  .setup-tooltip
    text-align: left;

  .text-detail
    color: #20a4c1;
    font-weight: bold;

  .text-order-number
    cursor: pointer;
</style>



// WEBPACK FOOTER //
// src/components/MapPopupRoute.vue